// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5811) return "static/chunks/5811.89d42ee61dc8dccb.js";
	if (chunkId === 3049) return "static/chunks/3049.b0adb6e778240d08.js";
	if (chunkId === 4935) return "static/chunks/e37a0b60.cb2ef3aec42cd9ea.js";
	if (chunkId === 353) return "static/chunks/353.056a4c9b8ace553b.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5105 ? "0e5ce63c" : chunkId) + "-" + {"1297":"130d529560211a3c","3281":"7b95491688976d43","5105":"0012bf4e32ed9df3","5476":"5b3fdd796251226a","7946":"cda22cf67eab5449"}[chunkId] + ".js";
};